import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import * as backInter from 'app/auth/auth-data.model';

import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { GestorStatusService } from '../../gestor-status.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-lista-status',
  templateUrl: './lista-status.component.html',
  styleUrls: ['./lista-status.component.scss'],
  animations : fuseAnimations
})
export class ListaStatusComponent implements OnInit {

  pasosWizard = [
    {
      id: 'idiomas',
      titulo: 'WIZARD.CERTIFICAR.STEPS.STP1.WIZBT',
      textoStatus: 'WIZARD.CERTIFICAR.STEPS.STP1.WIZBT',
      completado: false,
      activo: false,
      visible: true
    },
    {
      id: 'forall',
      titulo: 'WIZARD.CERTIFICAR.STEPS.STP2.WIZBT',
      textoStatus: 'WIZARD.CERTIFICAR.STEPS.STP2.WIZBT',
      completado: false,
      activo: false,
      visible: true
    },
    {
      id: 'demograficos',
      titulo: 'WIZARD.CERTIFICAR.STEPS.STP3.WIZBT',
      textoStatus: 'WIZARD.CERTIFICAR.STEPS.STP3.WIZBT',
      completado: false,
      activo: false,
      visible: true
    },
    {
      id: 'adicionales',
      titulo: 'WIZARD.CERTIFICAR.STEPS.STP4.WIZBT',
      textoStatus: 'WIZARD.CERTIFICAR.STEPS.STP4.WIZBT',
      completado: false,
      activo: false,
      visible: true
    },
    {
      id: 'colaboradores',
      titulo: 'WIZARD.CERTIFICAR.STEPS.STP5.WIZBT',
      textoStatus: 'WIZARD.CERTIFICAR.STEPS.STP5.WIZBT',
      completado: false,
      activo: false,
      visible: true
    },
    {
      id: 'programacion',
      titulo: 'WIZARD.CERTIFICAR.STEPS.STP6.WIZBT',
      textoStatus: 'WIZARD.CERTIFICAR.STEPS.STP6.WIZBT',
      completado: false,
      activo: false,
      visible: true
    },
    {
      id: 'envio',
      titulo: 'WIZARD.CERTIFICAR.STEPS.STP7.WIZBT',
      textoStatus: 'WIZARD.CERTIFICAR.STEPS.STP7.WIZBT',
      completado: false,
      activo: false,
      visible: true
    },
    {
      id: 'close',
      titulo: 'WIZARD.CERTIFICAR.STEPS.STP8.WIZBT',
      textoStatus: 'WIZARD.CERTIFICAR.STEPS.STP8.WIZBT',
      completado: false,
      activo: false,
      visible: true
    }
  ];

  productoSeleccionado = 0;

  hasForall = true;
  hasDemog = true;
  hasAdici = true;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private gestorStatService: GestorStatusService
  ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.gestorStatService.getAnioProducto.subscribe( (resu:number) => {
      this.productoSeleccionado = resu;
      // this.getStatuses(resu);
      this.getSeccionesProducto(localStorage.getItem('tipoProdInfo'),resu);
    });
  }
  ngOnInit() {
  }

  getSeccionesProducto(tipoProducto:string, resu:number){
    let datos: any = {};
    let nombres = {
      forall: 'Forall',
      demog: 'Demograficos',
      adic: 'Adicionales'
    }
    switch(tipoProducto){
      case "certify":
        datos = {fechaCertificar: resu};
        this.gestorStatService.getSeccionesCertificar(datos).subscribe((data:backInter.getSecciones) => {
          if(data.success){
            data.secciones.forEach( (seccion) => {
              switch(seccion.nombre){
                case nombres.forall:
                  this.hasForall = seccion.estatus;
                break;
                case nombres.demog:
                  this.hasDemog = seccion.estatus;
                break;
                case nombres.adic:
                  this.hasAdici = seccion.estatus;
                break;
              }
            });
          }
          this.getStatuses(resu);
        });
      break;
    }

  }

  getStatuses(anio:number){
    let datos: any = {};
    switch(localStorage.getItem('tipoProdInfo')){
      case 'certify': datos = {fechaCertificar: anio,	idiomas: 1}; break;
      case 'measurement': datos = {fechaMedir: anio,	idiomas: 1}; break;
      case 'pulse': datos = {fechaPulseCheck: anio,	idiomas: 1}; break;
      case 'focus': datos = {fechaFocus: anio,	idiomas: 1}; break;
    }

    this.gestorStatService.getAllStatus(datos).subscribe( (resu:any) => {
      // console.log(resu);
      if(resu.message == 'success'){
        let estatusSecciones = resu.estatusSecciones;
        this.pasosWizard.forEach( (paso) => {
          switch(paso.id){
            case 'idiomas': paso = this.activaSlider(estatusSecciones.idiomas, paso); break;
            case 'forall': paso = this.activaSlider(estatusSecciones.forall, paso); paso.visible = this.hasForall; break;
            case 'demograficos': paso = this.activaSlider(estatusSecciones.demograficos, paso); paso.visible = this.hasDemog; break;
            case 'adicionales': paso = this.activaSlider(estatusSecciones.adicionales, paso); paso.visible = this.hasAdici; break;
            case 'colaboradores': paso = this.activaSlider(estatusSecciones.colaboradores, paso); break;
            case 'programacion': paso = this.activaSlider(estatusSecciones.programacion, paso); break;
            case 'envio': paso = this.activaSlider(estatusSecciones.envio, paso); break;
            case 'close': paso = this.activaSlider(estatusSecciones.close, paso); break;
          }
        });
      }
    });
  }

  activaSlider(status:number, paso:any){
    switch(status){
      case 1: case 2: paso.activo = false; paso.completado = false; paso.textoStatus = 'GESTORSTATUS.STATUS.NO'; break;  //slider bloqueado y a la izquierda
      case 3: paso.activo = true; paso.completado = true; paso.textoStatus = 'GESTORSTATUS.STATUS.SI'; break;    //slider activo y a la derecha
    }
    return paso;
  }

  infoStatusMsg(){
    let texto = 'GESTORSTATUS.STATUS.INFO';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    // let texto = 'En esta lista se muestra el estado actual de cada paso del proceso de certificacion.\n\nPuede cambiar el estado de un paso completado a "No completado" haciendo clic en el selector de estado.\n\nNota: Algunos estados se pueden cambiar sólo bajo ciertas condiciones.';
    Swal.fire({
      title: texto,
      icon: 'info',
      confirmButtonColor: '#e40601'
    });
  }

  cambioSlider(e) {
    console.log(e);
    if(e.checked) {
      console.log("checado");
      if(confirm("Are you sure")) {
        console.log("toggle")
      }
      else {
        e.source.checked = false;
        console.log("toggle should not change if I click the cancel button")
      }
    }
  }

}
